import { Config } from './Config';

export function ExeConfig() : Config {
  return {
    CATALOG_INFO_PATH: './../../catalog/',
    RESOURCES_PATH: './../../catalog/res/',
    CATALOG_FILE_NAME: 'catalogInfo.json',
    CUSTOMIZATIONS_FILE_NAME: 'customizations_configuration.json',
    APPLICATION_TYPE: 'electron',
  };
}
